import { isMobile } from '@flowwai-frontend/shared/utils/web'

export const container = 'flex flex-col relative'

export const innerContainer = `
    p-3 mt-2
    rounded-[16px]
    bg-base-white    
    overflow-y-auto scrollbar 
    h-full
    shadow-lg
`

export const mobileHeaderToggleContainer =
   'flex justify-between items-center text-gray-700'

export const desktopHeaderToggleContainer =
   'flex items-center gap-2 text-gray-700 text-md-medium cursor-pointer'

export const coordinatesListContainer = `
   py-2 -my-2 
   scroll-container-with-fading-borders hidden-scrollbar
   ${isMobile() ? 'max-h-[244px]' : 'max-h-[488px]'}
`

export const animationProps = isMobile()
   ? {}
   : {
        initial: { x: -360, opacity: 0 },
        animate: { x: 0, opacity: 1 },
        transition: {
           type: 'spring',
           stiffness: 260,
           damping: 24,
           delay: 0.3
        }
     }
